import { menuClasses, sidebarClasses } from "react-pro-sidebar";
import { NavBarWrapper, NavMenu, NavMenuItem, NavSidebar } from "./NavBarWrapper";
import Icon from "../common/components/Icon";
import { useTranslation } from "react-i18next";

const PublicNavBar = () => {
    const { t } = useTranslation();
    const sidebar = <NavSidebar rootStyles={{
        [`.${sidebarClasses.container}`]: {
            backgroundColor: '#0AAEEF',
            color: 'white'
        },
        [`.${menuClasses.button}:hover`]: {
            backgroundColor: '#fbfbfb22 !important',
        },
        [`.${menuClasses.subMenuContent}`]: {
            backgroundColor: '#7D8082'
        },
        [`.${menuClasses.active}`]: {
                backgroundColor: '#00aeff',
        },
        [`.${menuClasses.active}.${menuClasses.button}:hover`]: {
            backgroundColor: '#72b0fe !important',
        },
        [`.${menuClasses.active}.${menuClasses.icon}`]: {
            backgroundColor: 'transparent',
        },
        [`.${menuClasses.active}.${menuClasses.label}`]: {
            backgroundColor: 'transparent',
        }
    }}>
        <NavMenu>
            <NavMenuItem path="/login" icon={<Icon variant="solid" kind="right-to-bracket"></Icon>}>{t('signIn')}</NavMenuItem>
        </NavMenu>
    </NavSidebar>
    
    return <NavBarWrapper sidebar={sidebar}
        image={<img src="/images/chronosoft_sm.png" alt="Orchestrator"></img>}
        style={{ backgroundColor: '#0AAEEF' }}
        bodyStyle={{ color: 'white', backgroundColor: '#166B7F' }}></NavBarWrapper>
}

export default PublicNavBar;